import Messages from "./components/Messages";
import Chat from "./components/Chat";
import NewChat from "./components/NewChat";
import Appointments from "./components/Appointments";
import useChatMessages from "../../hooks/useChatMessages";
import ChameVolks from "./components/chameVolks";

import "./styles.scss";

const ChatMessages = () => {
  const {
    loadingChats,
    amityChannels,
    channel,
    showSidebar,
    currentView,
    userId,
    handleOpenMessages,
    handleBackToList,
    handleNewChat,
    handleOpenScheduling,
    handleOpenChameVolks,
    toggleSidebar,
    usersData
  } = useChatMessages();

  if (!userId) return null;

  return (
    <div>
      <span className="indicated-icon" onClick={toggleSidebar}>
        <span className="rioglyph rioglyph-chat"></span>
        {
          amityChannels.some((channel) => channel.hasUnreadMessage) && 
            <span className="badge badge-indicator badge-danger height-20 width-20 text-size-11 padding-0 margin-top-10">
              {amityChannels.filter((channel) => channel.hasUnreadMessage).length}
            </span>
        }
      </span>

      {showSidebar && <div className="defaultProps">
        <div className="bg-chat-sidebar" onClick={toggleSidebar} />
        <div className="chat-sidebar">
          {currentView === "list" && 
            <Messages 
              loadingChats={loadingChats} 
              channels={amityChannels} 
              handleNewChat={handleNewChat} 
              handleOpenScheduling={handleOpenScheduling} 
              handleOpenMessages={handleOpenMessages} 
              handleOpenChameVolks={handleOpenChameVolks}
            />}

          {currentView === 'chat' && 
            <Chat 
              userId={userId} 
              channel={channel} 
              handleBackToList={handleBackToList} 
              usersData={usersData}
            />}

          {currentView === "newChat" && 
            <NewChat  
              handleBackToList={handleBackToList} 
              userId={userId} 
              handleOpenMessages={handleOpenMessages} 
              channels={amityChannels}
            />}

          {currentView === "appointments" && 
            <Appointments 
              handleBackToList={handleBackToList} 
            />}

          {currentView === "chameVolks" && 
            <ChameVolks handleBackToList={handleBackToList} />}
        </div>
      </div>}
    </div>
  );
};

export default ChatMessages;
